import CallHistoryItem from "./CallHistoryItem";

const CallHistory = ({clickHandler, clickAllowed, history = [], callUuid, debugMode = false}) => {
    const itemClickHandler = (index) => () => clickHandler(index);

    return <div className="flex min-w-0 flex-col gap-3 rounded-xl bg-slate-100 p-2">
        {history.map((data,index) => <CallHistoryItem clickAllowed={clickAllowed}
                                                      clickHandler={itemClickHandler(index)}
                                                      debugMode={debugMode}
                                                      history={data}
                                                      key={callUuid + "_call_history_" + index}/> )}
    </div>
};
export default CallHistory;
